// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__LUnzG","notes":"Notes_notes__3FFod"};